export default __webpack_public_path__ + "static/media/TinDog.5f5d3730.jpg";